import React from 'react'

import { Button, Grid, Modal, Typography } from '@mui/material'
import { Alerts, Loading } from '../../Simple'
import { LocalStorage, Services } from '../../../services'

import { BiX } from 'react-icons/bi'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import moment from 'moment'
import { EmpresasContext } from '../../../contexts/EmpresasContext'

import './stylesHF.css'

export default function SelecionaHoraFixa({ show, ClosedModal }) {
  const { sttPg } = React.useContext(EmpresasContext)
  const { sttCtxChkt, actionsChkt, loadCh } = React.useContext(CheckoutContext)

  const [sttMd, setSttMd] = React.useState({
    bttSel: sttCtxChkt.horaFixaSelecionada === null ? null : LocalStorage.get('bttSel-horaFixa'),
    conflito: false,
    periodo: 0,
  })
  /* Função que calcula o valor do horario fixo! */
  async function chama(idx) {
    const ress = await actionsChkt.SimulaHorarioFixo(Services.RetornaLabelMensalista(idx))
    if (ress.error) {
      setSttMd(sttMd => ({ ...sttMd, bttSel: null, periodo: 0 }))
    } else if (!ress.retorno) {
      setSttMd(sttMd => ({ ...sttMd, bttSel: null, periodo: 0 }))
    }
  }
  // 'T06:00:00'

  function SelecionaBttMes(idx) {
    if (sttMd.bttSel === idx) {
      setSttMd(sttMd => ({ ...sttMd, bttSel: null, periodo: 0 }))
    } else {
      if (sttCtxChkt.horaFixaSelecionada !== null) {
        setSttMd(sttMd => ({
          ...sttMd,
          bttSel: idx,
          periodo: Services.RetornaPeriodo(idx),
        }))
        chama(idx)
      } else {
        setSttMd(sttMd => ({
          ...sttMd,
          bttSel: idx,
          periodo: Services.RetornaPeriodo(idx),
        }))
        chama(idx)
      }
    }
  }

  function SelecionarHorarioFixo() {
    if (sttMd.bttSel !== null) {
      if (sttCtxChkt.cupomAplicado !== null) {
        Alerts.question('Aviso', 'Se você realizar esta ação, o cupom de desconto será removido. Deseja continuar?', () => {
          actionsChkt.SelecionaHorarioFixo()
          LocalStorage.set('bttSel-horaFixa', sttMd.bttSel)
          ClosedModal()
        })
      } else {
        actionsChkt.SelecionaHorarioFixo()
        LocalStorage.set('bttSel-horaFixa', sttMd.bttSel)
        ClosedModal()
      }
    }
  }

  function StartActionBtt() {
    function SalvarConfiguracao() {
      let flag = false
      if (sttMd.bttSel === 4) {
        sttCtxChkt.horaFixaSimulada.prePedidos.map(item => {
          if (item.status === 'OCUPADO') flag = true
        })
        if (!flag) SelecionarHorarioFixo()
        else {
          Alerts.swal(
            'Aviso',
            'Existem conflitos de horários, por favor contate o gestor da quadra para solicitar um agendamento fixo sem fim para este horário',
          )
        }
      } else {
        SelecionarHorarioFixo()
      }
    }
    if (sttCtxChkt.horaFixaSelecionada === null) {
      SalvarConfiguracao()
    } else {
      if (sttCtxChkt.horaFixaSimulada.tipoMensalista !== sttCtxChkt.horaFixaSelecionada.tipoMensalista) {
        SalvarConfiguracao()
      } else {
        actionsChkt.clearHorarioFixo()
        LocalStorage.remove('bttSel-horaFixa')
        ClosedModal()
      }
    }
  }

  function ClearHoraFixa() {
    actionsChkt.clearHorarioFixo()
    LocalStorage.remove('bttSel-horaFixa')

    ClosedModal()
  }

  function ButtonPP({ item, key }) {
    return (
      <button key={key} className={item.status === 'OCUPADO' ? 'btt-pre-pedido-hf-ocuped' : 'btt-pre-pedido-hf'}>
        <div className='container-btt-div-prehf'>
          <h3 className='text-hf-horario'>{Services.RetornaPeriodoSelect(sttCtxChkt.agendamentoConfirme.agenda)}</h3>
          <h4 className='text-hf-data'>{moment(item.dataInicio).format('D [de] MMMM [de] YYYY')}</h4>
        </div>
        <div className='container-btt-div-prehf'>
          {item.status === 'OCUPADO' ? (
            <>
              <h3 className='text-hf-ocup'>OCUPADO</h3>
            </>
          ) : (
            <>
              <h4 className='text-hf-value'>{`R$ ${item.valor.toFixed(2).toString().replace('.', ',')}`}</h4>
            </>
          )}
        </div>
      </button>
    )
  }

  function ReturnDuracao() {
    if (sttMd.bttSel === 4) {
      return 'Até ser cancelado'
    } else {
      const ar = ['1 mês', '3 meses', '6 meses', '1 ano']
      return `${ar[sttMd.bttSel]}`
    }
  }

  function ReturnValor() {
    if (sttCtxChkt.horaFixaSimulada.tipoMensalista === 'Indeterminado') {
      return 'R$ ' + sttCtxChkt.agendamentoConfirme.valorTotal.toFixed(2).toString().replace('.', ',')
    } else {
      return 'R$ ' + sttCtxChkt.horaFixaSimulada.valorTotal.toFixed(2).toString().replace('.', ',')
    }
  }
  React.useEffect(() => {
    if (!sttPg.selectedQuadra.precoFixo) {
      actionsChkt.BuscarPrecoFixoId()
    }
  }, [])

  React.useEffect(() => {
    if (sttMd.bttSel === null && sttCtxChkt.horaFixaSelecionada !== null) {
      setSttMd(sttMd => ({ ...sttMd, bttSel: LocalStorage.get('bttSel-horaFixa') }))
    } else if (sttMd.bttSel === null && sttCtxChkt.horaFixaSelecionada === null) {
      actionsChkt.handleSttCtxChkt('horaFixaSimulada', null)
    }
  }, [sttMd.bttSel])

  return (
    <Modal
      open={show}
      disableEnforceFocus
      className='contain-overlay-sel-hf'
      onClose={() => {
        if (sttCtxChkt.horaFixaSelecionada === null && sttCtxChkt.horaFixaSimulada !== null) {
          actionsChkt.handleSttCtxChkt('horaFixaSimulada', null)
        }
        ClosedModal()
      }}
    >
      <div className='contain-content-sel-hf'>
        <BiX
          className='icon-close-modal-hf'
          onClick={() => {
            if (sttCtxChkt.horaFixaSelecionada === null && sttCtxChkt.horaFixaSimulada !== null) {
              actionsChkt.handleSttCtxChkt('horaFixaSimulada', null)
            }
            ClosedModal()
          }}
        />
        <h1 className='text-title-hf'>Horário Fixo</h1>
        <h2 className='text-subtitle-hf'>Repetir esse horário durante?</h2>
        <>
          <div className='contain-btts-meses'>
            {/* Grade de botões para configurar horário fixo! */}
            {[
              { a: '1', b: 'MÊS' },
              { a: '3', b: 'MESES' },
              { a: '6', b: 'MESES' },
              { a: '1', b: 'ANO' },
              { a: 'SEM', b: 'FIM' },
            ].map((item, index) => {
              return (
                <button key={index} className={sttMd.bttSel === index ? 'btt-meses-hf-sel' : 'btt-meses-hf'} onClick={() => SelecionaBttMes(index)}>
                  <h2 className='text-btt-meses-hf'>{item.a}</h2>
                  <h2 className='text-btt-meses-hf'>{item.b}</h2>
                </button>
              )
            })}
          </div>
          {/* Renderiza os horarios de agendamento */}
          {loadCh.horaFx ? (
            <div className='contain-loading'>
              <Loading text={'Carregando...'} />
            </div>
          ) : sttCtxChkt.horaFixaSimulada !== null ? (
            <>
              <Grid container rowSpacing={0}>
                <Grid item xs={5}>
                  <Typography variant='body1' sx={stMd.textLabel}>
                    Dia da semana
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    variant='body1'
                    sx={{ ...stMd.textValue, color: 'var(--color-text-hig)', fontFamily: 'jost-mediun', fontWeight: 'default' }}
                  >
                    {Services.ReturnDiaSemana(
                      4,
                      new Date(
                        sttCtxChkt.agendamentoConfirme.dia.includes('T')
                          ? sttCtxChkt.agendamentoConfirme.dia
                          : sttCtxChkt.agendamentoConfirme.dia + 'T06:00:00',
                      ),
                    ).toUpperCase()}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant='body1' sx={stMd.textLabel}>
                    Horário
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant='body1' sx={stMd.textValue}>
                    {`${moment(sttCtxChkt.agendamentoConfirme.agenda[0].dataInicio).format('HH:mm')} às ${moment(
                      sttCtxChkt.agendamentoConfirme.agenda[sttCtxChkt.agendamentoConfirme.agenda.length - 1].dataFinal,
                    ).format('HH:mm')}`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant='body1' sx={stMd.textLabel}>
                    Começa em
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant='body1' sx={stMd.textValue}>
                    {`${moment(sttCtxChkt.agendamentoConfirme.dia).format('D [de] MMMM [de] YYYY')}`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant='body1' sx={stMd.textLabel}>
                    Durante
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant='body1' sx={stMd.textValue}>
                    {ReturnDuracao()}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant='body1' sx={stMd.textLabel}>
                    {sttCtxChkt.horaFixaSimulada.tipoMensalista === 'Indeterminado' ? 'Cada agendamento' : 'Valor total'}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant='body1' sx={{ ...stMd.textValue, fontFamily: 'jost-mediun' }}>
                    {ReturnValor()}
                  </Typography>
                </Grid>
              </Grid>
              <div className='contain-pre-agendamento-list'>
                {sttCtxChkt.horaFixaSimulada !== null && sttMd.bttSel !== 4 ? (
                  sttCtxChkt.horaFixaSimulada.prePedidos.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <ButtonPP item={item} />
                      </React.Fragment>
                    )
                  })
                ) : (
                  <></>
                )}
              </div>
              <div className='contain-btts-hf'>
                <Button
                  fullWidth
                  variant='text'
                  sx={stMd.bttAction}
                  disabled={sttCtxChkt.horaFixaSelecionada === null}
                  onClick={() => {
                    ClearHoraFixa()
                  }}
                >
                  Limpar
                </Button>
                <Button
                  fullWidth
                  variant='text'
                  sx={stMd.bttAction}
                  onClick={() => {
                    StartActionBtt()
                  }}
                >
                  Salvar
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    </Modal>
  )
}

const stMd = {
  textLabel: {
    fontFamily: 'jost-mediun',
    fontSize: '1.0rem',
    fontWeight: 'bold',
    textAlign: 'left',

    whiteSpace: 'nowrap',
  },
  textValue: {
    fontFamily: 'jost-light',
    fontSize: '1.0rem',
    fontWeight: 'bold',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  bttAction: {
    fontFamily: 'jost-mediun',
    fontSize: '1.1rem',
    color: 'var(--color-text-hig)',
    textTransform: 'none',
  },
}
